import { useDynamicScopes } from "@dynamic-labs/sdk-react-core";

import { EARLY_ACCESS_VIP_SCOPE } from "../dynamic.constants";

export const useUserScopes = () => {
  const { userHasScopes } = useDynamicScopes();

  const hasEarlyAccessVip = userHasScopes(EARLY_ACCESS_VIP_SCOPE);

  return {
    hasEarlyAccessVip,
  };
};
